const JoinStrings = (values) => values.filter((value) => value).join(', ');

export default JoinStrings;
